import gsap from 'gsap'
import RequestButtonFxd from '@/components/request-button/index.vue';
import RequestButton from '@/components/request-button/parts/request-button.vue';

export default {
 name: 'DataPage',
 components: {RequestButtonFxd, RequestButton},
 data() {
    return {
      number: 0,
      tweened: 0,
      val: 849500,
      val1: 4220500,
      val2: 628300,
      val3: 385000,
      val4: 213350,
      val5: 395225,
      counters: [
        { max:  69, text: 'Companies' },
        { max: 187, text: 'Million Executives' },
        { max: 703, text: 'Emails (99.5% accuracy, bounce <0.5%)' },
        { max: 700, text: 'Linkedin profiles' },
        { max: 701, text: 'Phones' },
        { max: 702, text: 'Photos' },
        
      ],
       max: 850000,
       max1: 4221322,
       max2: 628323,
       max3: 385050,
       max4: 213453,
       max5: 395352,
       imgs: {
        img1: require('@/landings/DATAPAGE/icon-05.png'),
        img2: require('@/landings/DATAPAGE/icon-04.png'),
        img3: require('@/landings/DATAPAGE/icon-02.png'),
        img4: require('@/landings/DATAPAGE/icon-03.png'),
        img5: require('@/landings/DATAPAGE/icon-07.png'),
        img6: require('@/landings/DATAPAGE/icon-06.png'),
        img7: require('@/landings/DATAPAGE/data7.png'),
        img8: require('@/landings/DATAPAGE/data8.png'),
        img9: require('@/landings/DATAPAGE/data11.png'),
        fst_scr: require('@/landings/DATAPAGE/fst_scr.png'),
        
       }
     
    }
  },
  // props: [ 'max', 'text' ],
  methods: {
    onScroll() {      
      // if (window.scrollY > 400)       
      if (this.$el.offsetTop + this.$el.offsetHeight < window.scrollY + window.innerHeight + 250) 
      {
        this.removeScrollHandler();
        const interval = setInterval(() => {
          if (this.val === this.max) {
            clearInterval(interval);
          } else{
            this.val=this.val+1
          }
        }, 3000/this.max);
      }
    },
    onScroll1() {
      // if (window.scrollY > 500)      
      if (this.$el.offsetTop + this.$el.offsetHeight < window.scrollY + window.innerHeight + 250) 
       {
        this.removeScrollHandler1();
        const interval = setInterval(() => {
          if (this.val1 === this.max1) {
            clearInterval(interval);
          } else{
            this.val1=this.val1+1
          }
        }, 3000/this.max1);
      }
    },
    onScroll2() {
      // if (window.scrollY > 500)
      
      if (this.$el.offsetTop + this.$el.offsetHeight < window.scrollY + window.innerHeight + 250) 
       {
        this.removeScrollHandler2();
        const interval = setInterval(() => {
          if (this.val2 === this.max2) {
            clearInterval(interval);
          } else{
            this.val2++
          }
        }, 3000/this.max2);
      }
    },
    onScroll3() {
      // if (window.scrollY > 500)
      
      if (this.$el.offsetTop + this.$el.offsetHeight < window.scrollY + window.innerHeight + 250) 
       {
        this.removeScrollHandler3();
        const interval = setInterval(() => {
          if (this.val3 === this.max3) {
            clearInterval(interval);
          } else{
            this.val3++
          }
        }, 3000/this.max3);
      }
    },
    onScroll4() {
      // if (window.scrollY > 500)
      
      if (this.$el.offsetTop + this.$el.offsetHeight < window.scrollY + window.innerHeight + 250) 
       {
        this.removeScrollHandler4();
        const interval = setInterval(() => {
          if (this.val4 === this.max4) {
            clearInterval(interval);
          } else{
            this.val4++
          }
        }, 3000/this.max4);
      }
    },
    onScroll5() {
      // if (window.scrollY > 500)
      
      if (this.$el.offsetTop + this.$el.offsetHeight < window.scrollY + window.innerHeight + 250) 
       {
        this.removeScrollHandler5();
        const interval = setInterval(() => {
          if (this.val5 === this.max5) {
            clearInterval(interval);
          } else{
            this.val5++
          }
        }, 3000/this.max5);
      }
    },    
    removeScrollHandler() {
      window.removeEventListener('scroll', this.onScroll);
      
    },
    removeScrollHandler1() {
      window.removeEventListener('scroll', this.onScroll1);      
    },
    removeScrollHandler2() {      
      window.removeEventListener('scroll', this.onScroll2);     
    },
    removeScrollHandler3() {      
      window.removeEventListener('scroll', this.onScroll3);      
    },
    removeScrollHandler4() {      
      window.removeEventListener('scroll', this.onScroll4);      
    },
    removeScrollHandler5() {      
      window.removeEventListener('scroll', this.onScroll5);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('scroll', this.onScroll1);
    window.addEventListener('scroll', this.onScroll2);
    window.addEventListener('scroll', this.onScroll3);
    window.addEventListener('scroll', this.onScroll4);
    window.addEventListener('scroll', this.onScroll5);
    this.$on('hook:beforeDestroy', this.removeScrollHandler);
    this.$on('hook:beforeDestroy', this.removeScrollHandler2);
    this.$on('hook:beforeDestroy', this.removeScrollHandler3);
    this.$on('hook:beforeDestroy', this.removeScrollHandler4);
    this.$on('hook:beforeDestroy', this.removeScrollHandler5);
    this.$on('hook:beforeDestroy', this.removeScrollHandler6);
    this.onScroll();
    this.onScroll1();
    this.onScroll2();
    this.onScroll3();
    this.onScroll4();
    this.onScroll5();
    gsap.to(this, { 
      duration: 1.9, 
      tweened: Number(850.000) || 0 
     }) 
     
  },
  
}